import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabat101MatchStore from "../../../../../stores/khattabat-stores/101m-stores";
import getKhattabat101MMessagingStore from "../../../../../stores/khattabat-stores/101m-stores/101m-messaging-store";
import getKhattabat101MGeneralStore from "../../../../../stores/khattabat-stores/101m-stores/general-101m-store";
import KhattabatMarkAsReadButton from "../../../khattabat-clients/conversation/body/side-actions/KhattabatMarkAsReadButton";

const KhattabatMatchActions = withLiteObserverAndTheme<{
  matchID: number;
}>((props) => {
  const { matchID } = props;
  const {
    conversationID,
    matchConvesationIsDisabled,
    matchConversationIsHighlighted,
    matchIsSlackAlertsEnabled,
    hasOneOTwoWithClient
  } = getKhattabat101MatchStore(matchID);
  const {
    updateOneOOneMIsHighlightedDataBase,
    updateOneOOneMSlackAlertsDataBase
  } = getKhattabat101MMessagingStore(matchID);
  const {
    disableEnableMatchConversationDatabase,
    ignoreMatchConversationDatabase
  } = getKhattabat101MGeneralStore();
  const isDisabledConversation = matchConvesationIsDisabled.get();

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      flexWrap="wrap"
      useFlexGap
    >
      <KhattabatMarkAsReadButton
        userID={matchID}
        conversationID={conversationID.get()}
      />
      <Button
        variant="outlined"
        color={isDisabledConversation ? "success" : "error"}
        onClick={() =>
          disableEnableMatchConversationDatabase({
            matchIDs: [matchID],
            enableAllConversations: false,
            disableAllConversations: false
          })
        }
      >
        {i18n.get(isDisabledConversation ? "ENABLE" : "DISABLE")}
      </Button>
      <Button
        variant="outlined"
        color="error"
        disabled={hasOneOTwoWithClient.get()}
        onClick={() => ignoreMatchConversationDatabase({ matchIDs: [matchID] })}
      >
        {i18n.get("IGNORE")}
      </Button>
      <FormControlLabel
        label={i18n.get("HIGHLIGHT")}
        control={
          <Switch
            checked={matchConversationIsHighlighted.get()}
            onChange={updateOneOOneMIsHighlightedDataBase}
          />
        }
      />
      <FormControlLabel
        label={i18n.get("SLACK_ALERTS")}
        control={
          <Switch
            checked={matchIsSlackAlertsEnabled.get()}
            onChange={updateOneOOneMSlackAlertsDataBase}
          />
        }
      />
    </Stack>
  );
});

export default KhattabatMatchActions;
